import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-home-option',
  templateUrl: './card-home-option.component.html',
  styleUrls: ['./card-home-option.component.css']
})
export class CardHomeOptionComponent implements OnInit {
  @Input() cardTitle:string=""
  @Input() imageName:string=""
  @Input() optionDetail=undefined
  imageFullPath:string=""
  constructor() { }

  ngOnInit(): void {
    this.imageFullPath=
    this.imageFullPath="/assets/images/optionshome/"+this.imageName
  }

}
